import { all } from 'redux-saga/effects';
import checkmateAuthorizationSaga from './checkmateAuthorizationSaga';
import transactionSaga from './transactionSaga';
import ordersPageSaga from './ordersPageSaga';
import paymentsPageSaga from './paymentsPageSaga';
import amazonWebServicesSaga from './amazonWebServicesSaga';
import storesPageSaga from './storePageSaga';
import merchantServiceSaga from './merchantServiceSaga';
import loginServiceSaga from './loginServiceSaga';
import accountServiceSaga from './accountServiceSaga';
import createAccountSaga from './adminFlow/createAccountSaga';
import merchantsDetailssaga from './adminFlow/merchantsInfoSaga';
import getStartedPageSaga from './getStartedPageSaga';
import onboardingMerchantsDetailsSaga from './adminFlow/onboardingmerchantsInfoSaga';
import onboardingBusinessDetailsSaga from './adminFlow/onboardingbusinessInfoSaga';
import approveBusinessDetailsSaga from './adminFlow/approvebusinessInfoSaga';
import rejectBusinessDetailsSaga from '../saga/adminFlow/rejectonboardbusinessSaga';

export default function* rootSaga() {
  yield all([
    checkmateAuthorizationSaga(),
    transactionSaga(),
    ordersPageSaga(),
    paymentsPageSaga(),
    storesPageSaga(),
    amazonWebServicesSaga(),
    merchantServiceSaga(),
    loginServiceSaga(),
    accountServiceSaga(),
    merchantsDetailssaga(),
    createAccountSaga(),
	getStartedPageSaga(),
	onboardingMerchantsDetailsSaga(),
	onboardingBusinessDetailsSaga(),
	approveBusinessDetailsSaga(),
	rejectBusinessDetailsSaga()
  ]);
}
